export const PERIODS = [
    {
        id: 1,
        name: 'До обеда (8:00 - 12:00)',
    },
    {
        id: 2,
        name: 'После обеда (12:00 - 18:00)',
    },
]

export const PERIODS_AFTERNOON = [
    {
        id: 2,
        name: 'После обеда (12:00 - 18:00)',
    },
]
